export default __webpack_public_path__ + "static/media/STL-Investors-Meet-June10.cd5f6bbb.pdf";